"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HodUserOnboarding = void 0;
const CommonUserOnboarding_1 = require("../../common/domain/CommonUserOnboarding");
const AdministrativeDocumentsStep_1 = require("./administrative/AdministrativeDocumentsStep");
const MeetingStep_1 = require("./meeting/MeetingStep");
const MatchingStep_1 = require("./matching/MatchingStep");
const HodOnboardingStepId_1 = require("./HodOnboardingStepId");
const OnboardingId_1 = require("../../common/domain/OnboardingId");
const validator_1 = require("@leavy/validator");
const BaseUserOnboardingStep_1 = require("../../common/domain/BaseUserOnboardingStep");
const HodGetToKnowUsStep_1 = require("./getToKnowUs/HodGetToKnowUsStep");
const infrastructure_1 = require("../../infrastructure");
const HodOnboardingExtraDataTypes_1 = require("./HodOnboardingExtraDataTypes");
const HodOnboardingStepTypes_1 = require("./HodOnboardingStepTypes");
const HodUserOnboardingRejectionInfo_1 = require("./HodUserOnboardingRejectionInfo");
class HodUserOnboarding extends CommonUserOnboarding_1.CommonUserOnboarding {
    constructor(id, data) {
        super(id);
        this.initialize(data);
    }
    isRejected() {
        return super.isRejected();
    }
    get onboardingId() {
        return this.id[1];
    }
    get matching() {
        return this.getStep(HodOnboardingStepId_1.HodOnboardingStepId.HOD_MATCHING, MatchingStep_1.MatchingStep);
    }
    get getToKnowUs() {
        return this.getStep(HodOnboardingStepId_1.HodOnboardingStepId.HOD_GET_TO_KNOW_US, HodGetToKnowUsStep_1.HodGetToKnowUsStep);
    }
    get administrativeDocuments() {
        return this.getStep(HodOnboardingStepId_1.HodOnboardingStepId.HOD_ADMINISTRATIVE_DOCS, AdministrativeDocumentsStep_1.AdministrativeDocumentsStep);
    }
    get meeting() {
        return this.getStep(HodOnboardingStepId_1.HodOnboardingStepId.HOD_MEETING, MeetingStep_1.MeetingStep);
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => HodUserOnboardingRejectionInfo_1.HodUserOnboardingRejectionInfo),
    __metadata("design:type", HodUserOnboardingRejectionInfo_1.HodUserOnboardingRejectionInfo)
], HodUserOnboarding.prototype, "rejectionInfo", void 0);
__decorate([
    (0, validator_1.Type)(() => BaseUserOnboardingStep_1.BaseUserOnboardingStep, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: "stepId",
            subTypes: Object
                .entries(HodOnboardingStepTypes_1.HodOnboardingStepTypes)
                .map(([name, value]) => ({ name, value })),
        },
    }),
    __metadata("design:type", Array)
], HodUserOnboarding.prototype, "steps", void 0);
__decorate([
    (0, validator_1.Type)(() => BaseUserOnboardingStep_1.BaseUserOnboardingStep, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: "dataTypeId",
            subTypes: Object
                .entries(HodOnboardingExtraDataTypes_1.HodOnboardingExtraDataTypes)
                .map(([name, value]) => ({ name, value })),
        },
    }),
    __metadata("design:type", Array)
], HodUserOnboarding.prototype, "extraData", void 0);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], HodUserOnboarding.prototype, "onboardingId", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", MatchingStep_1.MatchingStep),
    __metadata("design:paramtypes", [])
], HodUserOnboarding.prototype, "matching", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", HodGetToKnowUsStep_1.HodGetToKnowUsStep),
    __metadata("design:paramtypes", [])
], HodUserOnboarding.prototype, "getToKnowUs", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", AdministrativeDocumentsStep_1.AdministrativeDocumentsStep),
    __metadata("design:paramtypes", [])
], HodUserOnboarding.prototype, "administrativeDocuments", null);
__decorate([
    (0, infrastructure_1.ReadonlyGetter)(),
    __metadata("design:type", MeetingStep_1.MeetingStep),
    __metadata("design:paramtypes", [])
], HodUserOnboarding.prototype, "meeting", null);
exports.HodUserOnboarding = HodUserOnboarding;
//# sourceMappingURL=HodUserOnboarding.js.map